module.exports = __webpack_public_path__ + "img/yida.eea994cc.png";